var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.3307 9.73333V10.5C18.3297 12.297 17.7478 14.0456 16.6718 15.4849C15.5959 16.9241 14.0835 17.9771 12.3602 18.4866C10.6369 18.9961 8.79511 18.9349 7.10945 18.3122C5.4238 17.6894 3.98461 16.5384 3.00653 15.0309C2.02845 13.5234 1.56389 11.7401 1.68213 9.94693C1.80036 8.1538 2.49507 6.44694 3.66263 5.08089C4.83019 3.71485 6.40805 2.76282 8.16089 2.36679C9.91372 1.97076 11.7476 2.15195 13.3891 2.88333M18.3307 3.83333L9.9974 12.175L7.4974 9.675",
    stroke: "#BB3240",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDone);
export default __webpack_public_path__ + "static/media/notificationDone.0d7301fdeb546f999e333730ac38a460.svg";
export { ForwardRef as ReactComponent };